import { Controller } from "@hotwired/stimulus"

// Generic modal-trigger: clones a <template> with the configured id into <body>
// when a sibling element fires `modal-trigger#open` (typically a click).
//
// Usage in view:
//   <template id="my-modal-template">...modal markup w/ data-controller="modal"...</template>
//   <div data-controller="modal-trigger" data-modal-trigger-template-value="my-modal-template"></div>
//   <button data-action="click->modal-trigger#open">Open</button>
//
// The trigger element finds its <div data-controller="modal-trigger"> by walking
// up to the closest common ancestor (the controller scopes via Stimulus).
export default class extends Controller {
  static values = { template: String }

  connect() {
    console.log(`[modal-trigger] connect: template = ${this.templateValue}`)
  }

  open(event) {
    event?.preventDefault()
    const tpl = document.getElementById(this.templateValue)
    if (!tpl) {
      console.error(`[modal-trigger] template not found: ${this.templateValue}`)
      return
    }
    const clone = tpl.content.cloneNode(true)
    document.body.appendChild(clone)
    console.log(`[modal-trigger] opened modal from template ${this.templateValue}`)
  }
}
